import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditBankLawOffice = (props) => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [lawyerOptions, setLawyerOptions] = useState([]);
  const [bankLawyers, setBankLawyers] = useState([]);

  const fetchBanks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBankLawOffice", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var data = "";

          if (el.addressNew) {
            data = JSON.parse(el.addressNew);
          } else {
            data = {
              street: "",
              number: "",
              postCode: "",
              city: "",
            };
          }

          var addressTxt =
            data.street +
            " " +
            data.number +
            ", " +
            data.postCode +
            " " +
            data.city;

          if (!el.addressNew) {
            addressTxt = "";
          }

          var obj = {
            id: el.id,
            name: el.name,
            address: addressTxt,
            addressNew: data,
          };

          arr.push(obj);
        });
        setBankLawyers(arr);
        setLawyerOptions(createLawyerOptions(arr));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchBanks();
  };

  useEffect(() => {
    getData();
  }, []);

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        clientId: props.client.id,
        field: "lawoffice_bank",
        value: value,
      };

      fetch("https://apidevkppp.ftpeople.pl/updateFieldClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano informację o kanclearii pełnomocnika banku",
        props.client.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "sprawę",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const createLawyerOptions = (data) => {
    var bankOptions = [];
    bankOptions.push({ label: "brak danych", value: "brak danych" });
    data.map((el) => {
      bankOptions.push({ label: el.name + ", " + el.address, value: el.name });
    });

    return bankOptions;
  };

  return (
    <div style={{ width: "40vw" }} className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Kancelaria banku <span className="requiredStar">*</span>
              </label>
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                options={lawyerOptions}
                onChange={(e) => setValue(e.value)}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditBankLawOffice;
